import React from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink, Lightbulb } from 'lucide-react';

interface GuideLinkProps {
  href: string;
  icon: React.ReactNode;
  title: string;
  description: string;
}

const GuideLink: React.FC<GuideLinkProps> = ({ href, icon, title, description }) => {
  return (
    <a 
      href={href} 
      target="_blank" 
      rel="noopener noreferrer" 
      className="flex items-start p-4 rounded-lg bg-white border border-gray-200 hover:bg-gray-50 transition-colors"
    >
      <div className="flex-shrink-0 w-10 h-10 mr-4 flex items-center justify-center rounded-full bg-teal-50 text-teal-600">
        {icon}
      </div>
      <div>
        <div className="flex items-center mb-1">
          <h3 className="font-medium text-gray-900 mr-1">{title}</h3>
          <ExternalLink size={14} className="text-gray-400" />
        </div>
        <p className="text-sm text-gray-500">{description}</p>
      </div>
    </a>
  );
};

interface GuideLinksProps {
  subscription?: any;
}

export default function GuideLinks({ subscription }: GuideLinksProps) {
  const { t } = useTranslation();

  return (
    <div className="p-4 bg-gray-50 rounded-lg">
      <h2 className="font-semibold text-lg mb-4">{t('subscription.guideLinks.title', 'Piika Guides')}</h2>
      
      <div className="space-y-3">
        <GuideLink 
          href="https://guides.piika.co/guide/1"
          icon={<Lightbulb size={20} />}
          title={t('subscription.guideLinks.vasePreparation.title')}
          description={t('subscription.guideLinks.vasePreparation.description')}
        />
        
        <GuideLink 
          href="https://guides.piika.co/guide/2"
          icon={<Lightbulb size={20} />}
          title={t('subscription.guideLinks.flowerCare.title')}
          description={t('subscription.guideLinks.flowerCare.description')}
        />
      </div>
    </div>
  );
} 